
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const romanNumerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

const LoadingPlaceholder = () => (
  <div className="animate-pulse">
    <div className="h-8 bg-purple-100 rounded w-3/4 mb-4"></div>
    <div className="h-4 bg-purple-100 rounded w-1/2 mb-2"></div>
    <div className="h-4 bg-purple-100 rounded w-2/3"></div>
  </div>
);

const HousesSection = ({ loading, houses }) => {
  const [expandedHouse, setExpandedHouse] = useState(null);

  if (!loading && (!houses || houses.length === 0)) return null;

  const toggleHouse = (index) => {
    setExpandedHouse((prev) => (prev === index ? null : index));
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 border border-purple-100">
      {loading ? (
        <LoadingPlaceholder />
      ) : (
        <>
          <h2 className="font-serif text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
            Casas Astrologicas
          </h2>
          <div className="space-y-2">
            {houses?.map((casa, index) => {
              const isExpanded = expandedHouse === index;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.05 }}
                  className="rounded-lg border border-purple-50 overflow-hidden"
                >
                  <button
                    type="button"
                    onClick={() => toggleHouse(index)}
                    className="w-full flex items-center gap-3 p-3 hover:bg-purple-50 transition-colors text-left cursor-pointer"
                  >
                    <span className="w-8 h-8 rounded-full bg-purple-100 text-purple-700 flex items-center justify-center text-sm font-bold shrink-0">
                      {romanNumerals[index] || index + 1}
                    </span>
                    <h3 className="font-medium text-gray-800 flex-1">
                      {casa.Casa} - {casa.Area}
                    </h3>
                    <motion.span
                      animate={{ rotate: isExpanded ? 180 : 0 }}
                      transition={{ duration: 0.2 }}
                      className="text-purple-400 shrink-0"
                    >
                      <ChevronDown size={18} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isExpanded && (
                      <motion.div
                        key="content"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.25, ease: 'easeInOut' }}
                        className="overflow-hidden"
                      >
                        <p className="font-body text-sm text-gray-600 px-3 pb-3 ml-11 leading-relaxed">
                          {casa.Interpretacao}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default HousesSection;
